// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"881bcb61","641":"7a004240","667":"4044b129","683":"3f94408a"}[chunkId] + ".chunk.js";
};